import type {
  PortalUserAuditLogAction,
  PortalUserAuditLogFilterOption,
} from '../../store/modules/merchant/types';

const portalUserAuditLogActionLabels: Record<PortalUserAuditLogAction, string> = {
  create: 'Create',
  update: 'Edit',
  delete: 'Delete',
  sendAccessEmail: 'Access email sent',
};

const portalUserAuditLogFilterOptionLabels: Record<PortalUserAuditLogFilterOption, string> = {
  create: 'Create',
  update: 'Edit',
  delete: 'Delete',
  activation: 'Sign-up email sent',
  passwordReset: 'Password reset email sent',
};

export const getPortalUserAuditLogActionLabel = (action: PortalUserAuditLogAction) =>
  portalUserAuditLogActionLabels[action];

export const getPortalUserAuditLogFilterOptionLabel = (option: PortalUserAuditLogFilterOption) =>
  portalUserAuditLogFilterOptionLabels[option];
